"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monsummano-terme": {
    "bc9ba503": [{
      "hkey": "76a2fdd2",
      "slug": "cintolese-violi",
      "name": "Cintolese-Violi",
      "primary": true,
      "skipSearch": false
    }],
    "cintolese": [{
      "hkey": "76a2fdd2",
      "slug": "cintolese-violi",
      "name": "Cintolese-Violi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cfc7e0d6": [{
      "hkey": "d3ee4f62",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "grotta-parlanti": [{
      "hkey": "d3ee4f62",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monsummano-terme"
    }],
    "2ad89da5": [{
      "hkey": "76a2fdd2",
      "slug": "cintolese-violi",
      "name": "Cintolese-Violi",
      "primary": true,
      "skipSearch": false
    }],
    "violi": [{
      "hkey": "76a2fdd2",
      "slug": "cintolese-violi",
      "name": "Cintolese-Violi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monsummano-terme"
    }]
  }
};
exports["default"] = _default;